import React from "react"
export const Info: React.FC<any> = () => (
	<g stroke="none" strokeWidth="1" fillRule="evenodd">
		<path d="M13,0 C16.4478144,0 19.7544152,1.36963892 22.1923881,3.80761185 C24.6303611,6.24558476 26,9.55218563 26,13 C26,20.1797017 20.1797017,26 13,26 C5.82029825,26 0,20.1797017 0,13 C0,5.82029825 5.82029825,0 13,0 Z M13,2.6 C7.2562386,2.6 2.6,7.2562386 2.6,13 C2.6,18.7437614 7.2562386,23.4 13,23.4 C15.7582515,23.4 18.4035322,22.3042889 20.3539105,20.3539105 C22.3042889,18.4035322 23.4,15.7582515 23.4,13 C23.4,7.2562386 18.7437614,2.6 13,2.6 Z"></path>
		<polygon points="14.3 10.4 14.3 20.8 11.7 20.8 11.7 13 9.1 13 9.1 10.4"></polygon>
		<polygon points="14.3 5.2 14.3 7.8 11.7 7.8 11.7 5.2"></polygon>
	</g>
);
